/**
 * Directive orderIndividualMembership
 */

angular.module('acme.common.directive.contactSearch', [
    'acme.common.service.api',
    'acme.common.factory.gridState'
])
.directive('contactSearch', [function() {
    return {
        restrict: 'A',
        replace: true, 
        templateUrl: 'common/directives/contactSearch/contactSearch.tpl.html',
        scope: {
            comboIndex: '=',
            selectedContact: '='
        },

        link: function($scope, $element, $attrs) {

        },

        controller: [
            '$scope', 
            'ApiService', 
            'GridStateFactory',
            function(
                $scope, 
                ApiService,
                GridStateFactory
            ) {
                $scope.contactSearch = {
                    comboboxIndex: 0,
                    comboboxName: '',

                    comboboxSelectedContact: false,
                    comboboxContacts: [],

                    contactsGridState: new GridStateFactory(),
                    contactsPageSize: 10,

                    waitTime: 500,

                    init: function() {
                        this.comboboxIndex = $scope.boxIndex || 1;
                        this.comboboxName = 'order-contact-search-' + this.comboboxIndex;
                    },

                    comboboxSearchContacts: function(search) {
                        var self = $scope.contactSearch,
                            props = this.contactsGridState.getGridState();

                        props.pageSize = this.contactsPageSize;
                        props.search = search;
                        props.sortField = 'contactName' ;
                        props.sortDirection = 'asc';

                        ApiService.membership.summaries.search(props).then(function(res) {
                          self.comboboxContacts = res.data.payload.list.map(function(item) {
                            item.id = item.membershipId;
                            item.name = item.name;
                            return item;
                          });  


                          $scope.$broadcast('CustomTypehead::FilterResults', {field: 'combobox-input-' + self.comboboxName});
                        });
                    },

                    onComboboxContactChange: function() {
                        $scope.selectedContact = $scope.contactSearch.comboboxSelectedContact;
                    },
                };
            $scope.contactSearch.init();

        }]

    };
}]); 
